import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SpaceService } from './../../../../services/space.service';
import { MemberService } from './../../../../rest/api/member.service';
import { AuthService } from './../../../../services/auth.service';

@Component({
  selector: 'app-amount-showcase',
  templateUrl: './amount-showcase.component.html',
  styleUrls: ['./amount-showcase.component.scss']
})
export class AmountShowcaseComponent implements OnInit {
  spaceData: any;
  accessToken: any;
  constructor(
    public spaceService: SpaceService,
    public router: Router,
    private authService: AuthService,
    public memberService: MemberService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.spaceService.spaceDataSubscription.subscribe(response => {
      if (Object.keys(response).length === 0 && response.constructor === Object) {
        this.router.navigate(['/member']);
      }
      if (response) {
        this.spaceData = response;
      }
    });
  }

}
